import styled from "styled-components";

export const NavbarSeparatorDefaultBox = styled.div`
  align-self: center;
  height: 50%;
  border-left: 1px solid ${props => props.theme.colors.boxBorderLighter};
  margin-left: 1rem;
  padding-left: 1rem;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    margin-left: 0.5rem;
    padding-left: 0.5rem;
  }
`;
